import { useEffect, useState } from 'react'
import { getPlans } from '../../services/Plans';
import Cross from '../../icons/Cross';
import Loading from '../../icons/Loading';

type UpgradeSubscriptionProps = {
    showPopupUpgradeSubscription: boolean;
    setShowPopupUpgradeSubscription: (value: boolean) => void;
    planDetails: any;
    setShowPopupForPayment: (Value: boolean) => void;
    setUpgradePlan: (value: any) => void;
    activePaymentDetails: any | null;
    isProcessing: boolean;
    setIsProcessing: (value: boolean) => void;
    callTheAPIForUpgradeSubscription: (upgradedPlan: any, activePaymentDetails: any, cb: any) => void;
}

const UpgradeSubscription = ({
    showPopupUpgradeSubscription,
    setShowPopupUpgradeSubscription,
    planDetails,
    setShowPopupForPayment,
    setUpgradePlan,
    activePaymentDetails,
    isProcessing,
    setIsProcessing,
    callTheAPIForUpgradeSubscription
}: UpgradeSubscriptionProps) => {
    const [plans, setPlans] = useState<any>([]);
    const [plansDataIsLoaded, setPlansDataIsLoaded] = useState<boolean>(false);
    const [filterPlans, setFilterPlans] = useState<any>([]);
    const [processingPlanId, setProcessingPlanId] = useState<string | number | null>(null);

    useEffect(() => {
        getPlans()
            .then(res => {
                setPlans(res.reverse());
                setPlansDataIsLoaded(true);
            })
            .catch(error => {
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (plansDataIsLoaded && planDetails !== null) {
            let updateFilteredPlans = [];

            if (planDetails?.planName?.toLowerCase()?.includes('standard')) {
                if (planDetails?.billingCycle?.toLowerCase() === 'month') {
                    updateFilteredPlans = plans?.filter((plan: any) => !(plan?.planName?.toLowerCase()?.includes('standard') && plan?.billingCycle?.toLowerCase() === 'month'));
                } else {
                    updateFilteredPlans = plans?.filter((plan: any) => !plan?.planName?.toLowerCase()?.includes('standard'));
                }
            } else {
                if (planDetails?.billingCycle?.toLowerCase() === 'month') {
                    updateFilteredPlans = plans?.filter((plan: any) => plan?.planName?.toLowerCase()?.includes('premium') && plan?.billingCycle?.toLowerCase() === 'year');
                } else {
                    updateFilteredPlans = [];
                }
            }

            setFilterPlans(updateFilteredPlans);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [plansDataIsLoaded, planDetails, plans]);

    const closeModal = () => {
        setShowPopupUpgradeSubscription(false);
    }

    const upgradePlan = (value: any) => {
        setUpgradePlan(value);
        if (activePaymentDetails === null) {
            setShowPopupForPayment(true);
            closeModal();
        } else {
            if (!isProcessing) {
                setIsProcessing(true);
                setProcessingPlanId(value?.id);

                callTheAPIForUpgradeSubscription(value, activePaymentDetails, () => {
                    setProcessingPlanId(null);
                    closeModal();
                });
            }
        }
    }

    return (
        <div className={`fixed inset-0 p-4 mt-11 ${showPopupUpgradeSubscription ? "flex" : "hidden"} flex-wrap justify-center items-center w-full h-fit z-[1000] before:fixed before:inset-0 before:w-full before:min-h-[calc(100vh-72px)] before:bg-[rgba(0,0,0,0.5)] overflow-auto`}>
            <div className="w-full max-w-lg bg-white shadow-lg rounded-md relative">

                <div className="text-primary bg-secondary px-4 py-2 w-full flex justify-between items-center rounded-tl-md rounded-tr-md">
                    <h4 className="font-medium">Subscription Plan</h4>

                    {!isProcessing &&
                        <Cross
                            className="w-3 cursor-pointer shrink-0 fill-white active:fill-secondary float-right"
                            closeModal={closeModal}
                        />
                    }
                </div>

                <div className="flex flex-col p-4 gap-y-3">
                    <div className="flex gap-2 items-center">
                        <h5 className={`font-medium`}>
                            Current Plan:
                        </h5>

                        <p className={`p-0 font-normal text-sm`}>
                            {planDetails?.planName}
                            \<span className="capitalize">{planDetails?.billingCycle}</span>
                        </p>
                    </div>

                    {
                        filterPlans?.map((plan: any, index: number) => (
                            <div
                                key={index}
                                className={`flex gap-2 justify-between items-center border-b py-0.5`}
                            >
                                <div className="flex items-center gap-x-[0.25rem]">
                                    <h5 className={`font-medium`}>
                                        {plan?.planName}
                                        \<span className="capitalize">{plan?.billingCycle}:</span>
                                    </h5>

                                    <p className={`font-normal`}>${plan?.price}</p>
                                </div>

                                <button
                                    type="button"
                                    disabled={isProcessing}
                                    className={`rounded-md px-3 py-1 font-medium text-white ${isProcessing
                                        ? "bg-gray-400 cursor-not-allowed"
                                        : "bg-green-600"
                                        }`}
                                    onClick={() => upgradePlan(plan)}
                                >
                                    {processingPlanId === plan?.id ? (
                                        <Loading />
                                    ) : (
                                        "Upgrade"
                                    )}
                                </button>
                            </div>
                        ))}

                </div>

            </div>

        </div>
    )
}

export default UpgradeSubscription
